import { useLiveWireStore } from "@/stores/livewire";

const AppsClosedTodayWidget = () => {
  const daily = useLiveWireStore((state) => state.daily);
  return (
    <div className="apps-closed-today widget widget-md">
      <div className="card card-rounded">
        <div className="d-flex justify-content-between p-3 pb-0">
          <div>
            <span className="bi bi-send-check-fill text-orange me-2 fs-24"></span>
            <span className="text-black fw-bold fs-18 ">Closed Today</span>
          </div>
        </div>
        <div className="card-body pt-0 text-dark d-flex justify-content-center align-items-center">
          <div className="widget-value">{daily?.sent_to_qa}</div>
        </div>
      </div>
    </div>
  );
};

export default AppsClosedTodayWidget;
